import { KeyValue } from '@/main/models/common';
import {
  SupplierInventoryImportStatusTypes,
  SupplierInventoryImportStatusActionTypes
} from './supplierInventoryImportStatusTypes';

export function getSupplierInventoryImportStatus(): SupplierInventoryImportStatusActionTypes {
  return {
    type: SupplierInventoryImportStatusTypes.GET_SUPPLIER_INVENTORY_IMPORT_STATUS
  };
}

export function saveSupplierInventoryImportStatus(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): SupplierInventoryImportStatusActionTypes {
  return {
    type: SupplierInventoryImportStatusTypes.SAVE_SUPPLIER_INVENTORY_IMPORT_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerSuppliersInventoryImportStatus(): SupplierInventoryImportStatusActionTypes {
  return {
    type: SupplierInventoryImportStatusTypes.RESET_REDUCER_SUPPLIER_INVENTORY_IMPORT_STATUS
  };
}
